// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./fonts.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./cssTakenfromCdilWebsite.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --themeFontColor: #034EA2;
}

* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

#containerCustom {
  display: flex;
  flex-direction: column;
  font-family: "Ysabeau Office", sans-serif;
}

.gridParent,
.byLineDiv {
  width: 100%;
  display: flex;
}

.gridParent {
  flex-direction: column;
  align-items: center;
}

.gridDiv {
  width: 100%;
}

.byLineDiv {
  margin-bottom: 1rem;
  font-size: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
}

.byLineDiv>div {
  margin: 0.35rem 0rem;
  width: 100%;
}

.byLineDiv>div>input {
  height: 39.78px;
}

.byLineDiv>div>input,
.byLineDiv>div>select {
  width: 100%;
  padding: 0.25rem 0.5rem;
  font-size: 0.8rem;
  border: 1px solid #f0b128;
}

.byLineDiv>div>select {
  padding: 0.65rem 0.5rem;
  outline: none;
  cursor: pointer;
}

#search-box {
  height: 41.78px;
}

.me-3 {
  margin-right: 1rem;
}

.mb-3 {
  margin-bottom: 1rem;
}

#site>.wrapper2 {
  max-width: 97%;
  margin: 0 auto;
  position: relative;
  padding-top: 120px;
}

button {
  background-color: var(--themeFontColor);
  color: #ffffff;
  padding: 0.5rem 0.65rem;
  outline: none;
  border: none;
}

.customFieldHeader {
  height: 100%;
  width: 100%;
  padding-left: 0.75rem;
  padding-right: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 500 !important;
}

.deviceCompMainDiv {
  height: 100%;
  width: 100%;
}

.paragraphLink,
.link {
  color: var(--themeFontColor);
  font-weight: 600;
  cursor: pointer;
}

.annotationColor {
  color: var(--themeFontColor);
}

.flexBetween {
  justify-content: space-between !important;
}

.annotationsDiv {
  margin: 1rem 0rem;
  padding: 0.5rem;
  display: flex;
  justify-content: end;
}

tr>td:first-child {
  width: 20px;
}

.formGroup {
  display: flex;
  flex-direction: column;
  margin: 0.5rem 0rem;
  font-size: 1rem;
}

.formGroup>input,
.formGroup>textarea {
  background-color: white !important;
  outline: none;
  border: 1px solid rgb(163, 163, 163);
}

.submitBtnDiv {
  text-align: end;
}

.submitBtnDiv>button {
  width: 200px;
}

.sectionHeader {
  font-size: 1.4rem;
  margin-bottom: 0.75rem;
  color: var(--themeFontColor);
}

.packageDetailsDiv {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  margin-bottom: 1rem;
}

.packageDetailsDiv img {
  height: 100%;
  min-width: 100%;
  border: 1px solid black;
}

[data-close-button] {
  background-color: white !important;
  border-radius: 50%;
  border: 3px solid #e60000;
  color: red
}

@media screen and (min-width: 840px) {
  .byLineDiv {
    flex-direction: row;
  }

  .byLineDiv>div {
    width: 25%;
  }

  .byLineDiv>div>input,
  .byLineDiv>div>select {
    font-size: 1rem;
  }
}

@media screen and (min-width: 640px) {
  form#enquiryFormId>.flexDiv {
    display: flex;
    justify-content: space-between;
    gap: 0rem 1rem;
  }

  form#enquiryFormId>.flexDiv>div {
    width: 50%;
  }

  .packageDetailsDiv {
    flex-direction: row;
    max-height: 15rem;
  }

  .packageDetailsDiv>div {
    width: 50%;
  }

  .packageDetailsDiv div.gridLayout-2 {
    height: 50%;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/index.css"],"names":[],"mappings":"AAGA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;;EAEE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,uBAAuB;EACvB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,cAAc;EACd,uBAAuB;EACvB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;;EAEE,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,kCAAkC;EAClC,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,yBAAyB;EACzB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;IACb,8BAA8B;IAC9B,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["@import \"./fonts.css\";\n@import \"./cssTakenfromCdilWebsite.css\";\n\n:root {\n  --themeFontColor: #034EA2;\n}\n\n* {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n}\n\n#containerCustom {\n  display: flex;\n  flex-direction: column;\n  font-family: \"Ysabeau Office\", sans-serif;\n}\n\n.gridParent,\n.byLineDiv {\n  width: 100%;\n  display: flex;\n}\n\n.gridParent {\n  flex-direction: column;\n  align-items: center;\n}\n\n.gridDiv {\n  width: 100%;\n}\n\n.byLineDiv {\n  margin-bottom: 1rem;\n  font-size: 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n}\n\n.byLineDiv>div {\n  margin: 0.35rem 0rem;\n  width: 100%;\n}\n\n.byLineDiv>div>input {\n  height: 39.78px;\n}\n\n.byLineDiv>div>input,\n.byLineDiv>div>select {\n  width: 100%;\n  padding: 0.25rem 0.5rem;\n  font-size: 0.8rem;\n  border: 1px solid #f0b128;\n}\n\n.byLineDiv>div>select {\n  padding: 0.65rem 0.5rem;\n  outline: none;\n  cursor: pointer;\n}\n\n#search-box {\n  height: 41.78px;\n}\n\n.me-3 {\n  margin-right: 1rem;\n}\n\n.mb-3 {\n  margin-bottom: 1rem;\n}\n\n#site>.wrapper2 {\n  max-width: 97%;\n  margin: 0 auto;\n  position: relative;\n  padding-top: 120px;\n}\n\nbutton {\n  background-color: var(--themeFontColor);\n  color: #ffffff;\n  padding: 0.5rem 0.65rem;\n  outline: none;\n  border: none;\n}\n\n.customFieldHeader {\n  height: 100%;\n  width: 100%;\n  padding-left: 0.75rem;\n  padding-right: 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-weight: 500 !important;\n}\n\n.deviceCompMainDiv {\n  height: 100%;\n  width: 100%;\n}\n\n.paragraphLink,\n.link {\n  color: var(--themeFontColor);\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.annotationColor {\n  color: var(--themeFontColor);\n}\n\n.flexBetween {\n  justify-content: space-between !important;\n}\n\n.annotationsDiv {\n  margin: 1rem 0rem;\n  padding: 0.5rem;\n  display: flex;\n  justify-content: end;\n}\n\ntr>td:first-child {\n  width: 20px;\n}\n\n.formGroup {\n  display: flex;\n  flex-direction: column;\n  margin: 0.5rem 0rem;\n  font-size: 1rem;\n}\n\n.formGroup>input,\n.formGroup>textarea {\n  background-color: white !important;\n  outline: none;\n  border: 1px solid rgb(163, 163, 163);\n}\n\n.submitBtnDiv {\n  text-align: end;\n}\n\n.submitBtnDiv>button {\n  width: 200px;\n}\n\n.sectionHeader {\n  font-size: 1.4rem;\n  margin-bottom: 0.75rem;\n  color: var(--themeFontColor);\n}\n\n.packageDetailsDiv {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  width: 100%;\n  margin-bottom: 1rem;\n}\n\n.packageDetailsDiv img {\n  height: 100%;\n  min-width: 100%;\n  border: 1px solid black;\n}\n\n[data-close-button] {\n  background-color: white !important;\n  border-radius: 50%;\n  border: 3px solid #e60000;\n  color: red\n}\n\n@media screen and (min-width: 840px) {\n  .byLineDiv {\n    flex-direction: row;\n  }\n\n  .byLineDiv>div {\n    width: 25%;\n  }\n\n  .byLineDiv>div>input,\n  .byLineDiv>div>select {\n    font-size: 1rem;\n  }\n}\n\n@media screen and (min-width: 640px) {\n  form#enquiryFormId>.flexDiv {\n    display: flex;\n    justify-content: space-between;\n    gap: 0rem 1rem;\n  }\n\n  form#enquiryFormId>.flexDiv>div {\n    width: 50%;\n  }\n\n  .packageDetailsDiv {\n    flex-direction: row;\n    max-height: 15rem;\n  }\n\n  .packageDetailsDiv>div {\n    width: 50%;\n  }\n\n  .packageDetailsDiv div.gridLayout-2 {\n    height: 50%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
